import React from 'react';

export default ({ className }) => (
  <svg className={className}width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 2L13.1962 5V5.17786L12.3301 5.64598V5.5L8 3L3.66987 5.5V10.5L8 13L12.3301 10.5V5.77033L13.1962 5.29553V11L8 14L2.80385 11V5L8 2Z"/>
    <path
      d="M5.24275 4.42875L9.59657 7.04104L8 7.92803L3.74282 5.56293C3.50143 5.42882 3.19703 5.51579 3.06292 5.75718C2.92881 5.99858 3.01579 6.30298 3.25718 6.43708L7.5 8.79421V13.5H8.5V8.79421L12.7428 6.43708C12.7641 6.42525 12.7842 6.41208 12.8031 6.39775L13.1953 6.19531V5.04688L12.2779 5.55201C12.271 5.55547 12.2641 5.55911 12.2572 5.56293L12.1523 5.62118L11.9609 5.72656L10.6058 6.48037L5.75725 3.57126L5.24275 4.42875Z"/>
  </svg>
);
